import {
    TextareaAutosize as BaseTextareaAutosize,
    TextareaAutosizeProps,
} from "@mui/base/TextareaAutosize";
import { styled } from "@mui/system";

type TextareaProps = TextareaAutosizeProps;

export default function Textarea(props: TextareaProps) {
    const Textarea = styled(BaseTextareaAutosize)(
        ({ theme }) => `        
        display: flex;
        padding: 1rem;
        align-items: center;
        gap: 0.5rem;
        align-self: stretch;
        border-radius: 1rem;
        border: none;
        background: #FFF;
        /* Ombre card */
        box-shadow: 0px 4px 30px 0px #E3E6E8;`
    );

    return <Textarea {...props} />;
}
